import dayjs from 'dayjs'

export const resolveObjProp = (path, obj, separator = '.') => {
  const properties = Array.isArray(path) ? path : path.split(separator)
  return properties.reduce((prev, curr) => prev && prev[curr], obj)
}

export const removeNullUndefined = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))

export const handleErrorMessage = (error, defaultErrorMessage) => {
  console.log(error)
  if (error.response && error.response.data.message && Array.isArray(error.response.data.message))
    return error.response.data.message.join(' & ')
  if (error.response && error.response.data.message) return error.response.data.message
  return defaultErrorMessage ? defaultErrorMessage : error.message
}

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) return -1
  if (b[orderBy] > a[orderBy]) return 1
  return 0
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const isBoolean = (n) => !!n === n
export const isNumber = (n) => +n === n
export const isString = (n) => '' + n === n

export const displayHumanBytes = (bytes, dm = 2) => {
  if (bytes == 0) return '0 Bytes'
  const k = 1024,
    sizes = [`${bytes <= 1 ? 'Byte' : 'Bytes'}`, 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const resolveAndDownloadBlob = (response, filename) => {
  filename = decodeURI(filename)
  const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  window.URL.revokeObjectURL(url)
  link.remove()
}

export const standarizeStatus = (status) => status.toLowerCase()

export const formatMoney = (value, skipSymbol = false) => {
  if (typeof value === 'string') value = parseFloat(value)
  // eslint-disable-next-line no-undef
  return Intl.NumberFormat(
    'pl-Pl',
    skipSymbol
      ? {}
      : {
          style: 'currency',
          currency: 'PLN',
          currencyDisplay: 'narrowSymbol',
        }
  ).format(value)
}

export const isDateBefore = (compare, now = dayjs()) => dayjs(compare).isBefore(now, 'days')
export const isDateBeforeOrToday = (compare, now = dayjs()) =>
  dayjs(compare).isBefore(now, 'days') || dayjs(compare).isSame(now, 'days')
export const isDateToday = (compare, now = dayjs()) => dayjs(compare).isSame(now, 'days')
export const isDateAfterOrToday = (compare, now = dayjs()) =>
  dayjs(compare).isAfter(now, 'days') || dayjs(compare).isSame(now, 'days')
export const isDateAfter = (compare, now = dayjs()) => dayjs(compare).isAfter(now, 'days')

export const sortByDate = (arr) => [...arr].sort((a, b) => new Date(a.date) - new Date(b.date))
export const sortBy = (arr, propToSort, propToSort2 = null) =>
  [...arr].sort((a, b) => {
    const valA = a[propToSort] ?? ''
    const valB = b[propToSort] ?? ''

    let result = String(valA).localeCompare(String(valB))

    if (propToSort2 && result === 0) {
      const valA2 = a[propToSort2] ?? ''
      const valB2 = b[propToSort2] ?? ''
      result = String(valA2).localeCompare(String(valB2))
    }

    return result
  })

export const isTaskStatusOpen = (task, serverTime) => !task.assignment && isDateAfter(task.date, serverTime)

export const addComputedFullName = (user) => {
  if (user.fullName) return user
  else if (user.firstName && user.lastName) return { ...user, computedFullName: `${user.firstName} ${user.lastName}` }
  return user
}

export const removeDuplicates = (arr) => [...new Set(arr)]

export const computeSalaryByProject = (project, task) => {
  let computedSalary = 0
  if ([1, 3].includes(project.type)) computedSalary = Number(project.hourlyRate) * Number(task.hoursCount)
  else if (project.type == 2) computedSalary = task.rate
  return computedSalary
}

export const standarizeTaskObj = (task) => ({
  ...task,
  computedType: task.project.type,
  computedSalary: computeSalaryByProject(task.project, task),
  standardized: {
    date: task.date,
    localization: task.localization || task.project.location,
    notes: task.notes,
  },
})
